import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import { showModal, hideModal } from 'appSrc/redux/actions';
import EditListModal from '../../Modals/List/EditListModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllListsTable extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            listInEdit: null,
            listInEditIndex: -1,
        };
    }
    updateList =( index, listid, data ) => {
        this.props.updateList( listid, data )
        .then( ( list ) => {
            return this.props.onListUpdated && this.props.onListUpdated( index, list );
        } );
    }
    openEditModal = ( index, user ) => {
        this.setState( { listInEdit: user, listInEditIndex: index } );
        this.props.showModal( 'editListModal' );
    }
    onEditSubmit = ( updates ) => {
        var index = this.state.listInEditIndex;
        var oldList = this.state.listInEdit;
        var calls = [];
        for( var i = 0; i < updates.tags.newTags.length; i++ ) {
            var tag = updates.tags.newTags[ i ];
            calls.push( this.props.addTagToList( oldList.listid, tag.tagtext ) );
        }
        for( var j = 0; j < updates.tags.deletedTags.length; j++ ) {
            var dTag = updates.tags.deletedTags[ j ];
            calls.push( this.props.deleteTagFromList( oldList.listid, dTag.tagtext ) );
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateList( oldList.listid, updates.list );
        } )
        .then( ( updatedList ) => {
            this.props.onListUpdated( index, updatedList );
            return updatedList;
        } );
    }
    onEditDelete = () => {
        var index = this.state.listInEditIndex;
        var oldList = this.state.listInEdit;
        return this.props.deleteList( oldList.listid )
        .then(() => {
            this.props.onListDeleted( index, oldList );
            return oldList;
        });
    }
    onEditClose = () => {
        this.props.hideModal( 'editListModal' );
        this.setState( { listInEdit: null, listInEditIndex: -1 } );
    }

    render() {
        const { lists } = this.props;

        return (
            <div>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( lists ) }
                </InfiniteTable>
                { this.state.listInEdit &&
                    <EditListModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    onDelete={ this.onEditDelete }
                    list={ this.state.listInEdit } />
                }
            </div>
        );
    }


    arrayTableRows = ( lists ) => {
        var rows = lists.map( ( list, index ) => {
            var author = list.author || {};
            var individualSlug = `/admin/lists/${ list.listid }`;
            return (
                <InfiniteTable.Row key={ list.listid } className='dl-table-body'>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        <TextTruncate text={ list.title }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { author.displayName }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { list.categories.map( category => category.name ).join( ', ' ) }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }></Link>
                        { list.desires.length }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }></Link>
                        { list.featured !== null ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inheirit' } } /> ) : null }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, list );
                            } }/>
                            <DLMenu.Item text={ list.deactivated ? 'Activate' : 'Deactivate' }
                            onClick={ () => {
                                this.updateList( index, list.listid, {
                                    deactivated: !list.deactivated,
                                    title: list.title,
                                } );
                            } }/>
                            <DLMenu.Item text={ list.featured ? 'UnFeature' : 'Feature' }
                            onClick={ () => {
                                this.updateList( index, list.listid, {
                                    featured: !list.featured,
                                    title: list.title,
                                } );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );
        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    LIST NAME { sortIcon( 'title' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    USER { sortIcon( 'author."displayName"' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    CATEGORY { sortIcon( 'categories.name,title' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    PRODUCTS
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    FEATURED { sortIcon( 'featured,title' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
AllListsTable.defaultProps = {
    onListUpdated: ()=>{},
    onListDeleted: ()=>{},
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        updateList: ( listid, data ) => {
            return dAPI.patch( `/lists/${ listid }`, dAPI.clean.list( data ) );
            
        },
        deleteList: ( listid ) => {
            return dAPI.delete( `/lists/${ listid }` );
            
        },
        addTagToList: ( listid, newTag ) => {
            return dAPI.post( `/lists/${ listid }/tag`, { tag: newTag } );
            
        },
        deleteTagFromList: ( listid, tagtext ) => {
            return dAPI.delete( `/lists/${ listid }/tag/${ tagtext }` );
            
        },
    };
};

export default connect( null, mapDispatchToProps )( AllListsTable );
